import { render } from "./Main.vue?vue&type=template&id=8e3cd8aa"
const script = {}
script.render = render

export default script